// import { useGetProductsQuery } from "@/redux/feature/product/productApi";
import Modal from "@/components/ui/Modal";
import React, { useState } from "react";
import SubRedditModal from "../ProductCollections/components/CompetitorVideos/SubRedditModal";
import { CustomButton } from "@/components/ui/Buttons";
import { Plus } from "lucide-react";

const Test = () => {
  // const { data, isLoading, error } = useGetProductsQuery();

  // console.log("API response:", data);
  const [isSubredditOpen, setIsSubredditOpen] = useState(false);
  return (
    <div className="flex justify-center items-center min-h-screen">
      <CustomButton
        onClick={() => setIsSubredditOpen(true)}
        variant="outline"
        border="1px solid #D3D3D3"
        borderRadius="8px"
        padding="7px 13px"
        color="#0D0D0D"
        fontWeight="500"
        fontSize="16px"
        className="leading-6 tracking-normal flex items-center gap-x-2"
      >
        <span>
          <Plus />
        </span>
        Add a Subreddit or Keyword
      </CustomButton>

      <Modal
        isOpen={isSubredditOpen}
        setOpen={setIsSubredditOpen}
        width="513px"
        padding="20px 14px"
      >
        <SubRedditModal setOpen={setIsSubredditOpen} />
      </Modal>
    </div>
  );
};

export default Test;
